module.exports = __webpack_public_path__ + "img/Alexcoutcharmtable06.19382260.jpg";